var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"markdown-editor"},[_c('mavon-editor',{ref:"markdownEditor",attrs:{"xssOptions":{
    whiteList: {
      svg: ['*'], path: ['*'], g: ['*'], span: ['class', 'style'], table: ['*'],
      tr: ['*'],
      td: ['*'],
      th: ['*'],
      thead: ['*'],
      tbody: ['*']
    }
  },"toolbars":_vm.mergedToolbars,"subfield":_vm.subfield,"defaultOpen":_vm.defaultOpen,"editable":_vm.editable,"toolbarsFlag":_vm.toolbarsFlag,"placeholder":_vm.placeholder,"math":true,"katexOption":_vm.katexOption,"ishljs":_vm.ishljs,"externalLink":{
      mermaid_js: () => ''
    }},on:{"change":_vm.handleChange,"save":_vm.handleSave,"full-screen":_vm.handleFullscreen,"previewToggle":_vm.previewToggle,"subfieldToggle":_vm.subfieldToggle},model:{value:(_vm.currentContent),callback:function ($$v) {_vm.currentContent=$$v},expression:"currentContent"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }